import { SPSELECTS } from "InterfacesTypes/enums";
import type { ISharepointSearchResponse, ISharepointSearchRow, IUpdatedPagesFiles } from "InterfacesTypes/interfaces";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchFailure,
  fetchRecentlyUpdatedFiles,
  fetchStart,
  fetchSuccess,
} from "state/Reducers/RecentlyUpdatedFilesReducer";

import { spGet, spPost } from "utils/SharepointAPI";
import { getEnvironment } from "utils/utils";

const env = getEnvironment();
function* fetchRecentlyUpdatedFilesWorker() {

  // const requestOnlyIntEsp = `Path:"https://logp.fmv.se/tjansterprodukter/internationellspedition" AND IsDocument:1 AND NOT ContentType:Folder AND (FileExtension:doc OR FileExtension:docx OR FileExtension:xls OR FileExtension:xlsx OR FileExtension:pdf) AND LastModifiedTime>=2020-01-01T00:00:00Z`;
  // const requestNotIntEsp = `Path:"https://logp.fmv.se" AND IsDocument:1 AND NOT Path:"https://logp.fmv.se/tjansterprodukter/internationellspedition" AND NOT ContentType:Folder AND (FileExtension:doc OR FileExtension:docx OR FileExtension:xls OR FileExtension:xlsx OR FileExtension:pdf) AND LastModifiedTime>=2020-01-01T00:00:00Z`;
  
  const one = ["https://logp.fmv.se/tjansterprodukter/Avveckling/*", "https://logp.fmv.se/tjansterprodukter/ils/*"];

  //const X = `${one.map(s => `Path:"${s}/*"`).join(" OR ")}`;
  const X = `${one.map(s => `Site:"${s}"`).join(" OR ")}`;

  
  //WORKING!!!
  const OnlyAvvecklingAndILS = `(${X}) AND IsDocument:1 AND NOT ContentType:Folder AND (FileExtension:doc OR FileExtension:docx OR FileExtension:xls OR FileExtension:xlsx OR FileExtension:pdf) AND LastModifiedTime>=2020-01-01T00:00:00Z`;
  //const OnlyAvvecklingAndILS = `(Site:"https://logp.fmv.se/tjansterprodukter/Avveckling/*") AND IsDocument:1 AND NOT ContentType:Folder AND (FileExtension:doc OR FileExtension:docx OR FileExtension:xls OR FileExtension:xlsx OR FileExtension:pdf) AND LastModifiedTime>=2020-01-01T00:00:00Z`;

  try {
    yield put(fetchStart());
    if (window.location.hostname === "localhost") {
      const updatedFilesUrl = `${env.listapi}/GetByTitle('RecentlyUpdatedFiles')/Items?$top=5000&$select=${SPSELECTS.RECENTLYUPDATEDFILES}`;
      const data: IUpdatedPagesFiles[] = yield call(spGet, updatedFilesUrl);
      yield put(fetchSuccess(data));
    } else {
      const response: ISharepointSearchResponse = yield call(spPost, env.baseUrl + "/_api/search/postquery", createRequest(OnlyAvvecklingAndILS)); 
      // const responseNotIntEsp: ISharepointSearchResponse = yield call(spPost, env.baseUrl + "/_api/search/postquery", createRequest(requestNotIntEsp));
      // const responseOnlyIntEsp: ISharepointSearchResponse = yield call(spPost, env.baseUrl + "/_api/search/postquery", createRequest(requestOnlyIntEsp));
      // // const response: ISharepointSearchResponse = yield call(spPost, "https://logp.fmv.se/_api/search/postquery", request);
      // //const files = response.PrimaryQueryResult.RelevantResults.Table.Rows;
      
      // const response = [
      //   ...responseNotIntEsp.PrimaryQueryResult.RelevantResults.Table.Rows, 
      //   ...responseOnlyIntEsp.PrimaryQueryResult.RelevantResults.Table.Rows
      // ];
      // console.log("Files incoming from sharepoint", response); //Shows all the files incoming from sharepoint with their properties.

      const unsortedResults: IUpdatedPagesFiles[] = response.PrimaryQueryResult.RelevantResults.Table.Rows.map((row: ISharepointSearchRow): IUpdatedPagesFiles => {
        const cells = row.Cells.reduce<Record<string, string>>((acc, cell) => {
          acc[cell.Key] = cell.Value;
          return acc;
        }, {}); 
          
        return {
          Title: cells.Title?? "",
          Link: cells.Path ?? "",
          Date: new Date(cells.LastModifiedTime),
          Filetype: cells.FileExtension?? "",
          SPUrl: cells.SPWebUrl?? "",
        };
      });

      const results = [...unsortedResults].sort((a, b) => {
        if (!a.Date && !b.Date) return 0;
        if (!a.Date) return 1;
        if (!b.Date) return -1;

        return (
          new Date(b.Date).getTime() - new Date(a.Date).getTime()
        );
      });

      const siteTitleMap: Record<string, string> = yield call(fetchSiteTitles, results);
      
      const completedFileObjects = results.map(x => ({
        ...x,
        SiteTitle: siteTitleMap[x.SPUrl?? ""] ?? "",
      }));

      yield put(fetchSuccess(completedFileObjects));
    }
  } catch (err: any) {
    yield put(fetchFailure(err?.message ?? "Något gick fel"));
  }
}

export function* recentlyUpdatedFilesSaga() {
  yield takeLatest(
    fetchRecentlyUpdatedFiles.type,
    fetchRecentlyUpdatedFilesWorker
  );
}

function createRequest(queryText: string) {
  const request = {
    request: {
      // "Querytext": `Path:"https://logp.fmv.se" AND IsDocument:1 AND NOT ContentType:Folder AND (FileExtension:doc OR FileExtension:docx OR FileExtension:xls OR FileExtension:xlsx OR FileExtension:pdf) AND LastModifiedTime>=2020-01-01T00:00:00Z`,
      "Querytext": queryText,
    RowLimit: 50,
    SortList: [
      {
        Property: "LastModifiedTime",
        Direction: 1,
      }
    ],
    SelectProperties: [
      // "Title",
      // "Path",
      // "LastModifiedTime"
    ]
    }
  }
  return request;
}

function* fetchSiteTitles(
    results: IUpdatedPagesFiles[]
): Generator<any, Record<string, string>, any> {
    const uniqueSpUrls = Array.from(
        new Set(results.map(x => x.SPUrl).filter(Boolean))
    );
    const siteTitleMap: Record<string, string> = {};

    for (const spUrl of uniqueSpUrls) {
        try{
            const title = yield call(spGet, `${spUrl}/_api/web?$select=Title`);
            siteTitleMap[spUrl?? ""] = title.Title;
        } catch (e) {
            console.log("Error in 'fetchSiteTitles': ", e);
            siteTitleMap[spUrl?? ""] = "";
        }
    }


    return siteTitleMap;
}